import React from 'react';
import { motion } from 'framer-motion';

const HowItWorks: React.FC = () => {
  const steps = [
    {
      number: '01',
      title: 'Выберите фильм',
      description: 'Найдите любимый фильм или сериал с помощью нашей поисковой системы на базе IMDb.',
      color: 'step-blue'
    },
    {
      number: '02',
      title: 'Настройте язык',
      description: 'Выберите целевой язык, уровень владения (B1-C2) и предпочтительный стиль речи.',
      color: 'step-indigo'
    },
    {
      number: '03',
      title: 'Создайте словарь',
      description: 'Наш ИИ анализирует субтитры и создает персонализированный список слов с контекстными примерами.',
      color: 'step-purple'
    },
    {
      number: '04',
      title: 'Изучайте и повторяйте',
      description: 'Просматривайте ваш словарь, сохраняйте слова и отслеживайте прогресс в обучении.',
      color: 'step-pink'
    }
  ];

  return (
    <section id="how-it-works" className="how-it-works-section">
      <div className="container">
        <motion.div 
          className="section-header"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
        >
          <h2 className="section-title pencil-text">Как работает LinguaSub</h2>
          <p className="section-description pencil-text">
            Простой четырехэтапный процесс, который преобразит ваш опыт изучения языка
          </p>
        </motion.div>

        <div className="timeline">
          <div className="timeline-connector"></div>
          <div className="timeline-steps">
            {steps.map((step, index) => (
              <motion.div 
                key={index}
                className={`step-container ${index % 2 === 0 ? 'step-right' : 'step-left'}`}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}
              >
                <div className="step-card">
                  <div className={`step-number ${step.color}`}>
                    {step.number}
                  </div>
                  <h3 className="step-title pencil-text">{step.title}</h3>
                  <p className="step-description pencil-text">{step.description}</p>
                </div>
                <div className="step-dot"></div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks; 